import { useTranslation } from 'react-i18next';
import logo from '../../assets/zaddons_logo.png';
import './NotFound.scss';

const NotFound = () => {
    const { t } = useTranslation('common', { keyPrefix: 'notFound' });

    return (
        <div className="not-found-page">
            <div className="not-found-content">
                <img
                    src={logo}
                    alt=""
                    width="200px"
                    height="40px"
                    className="block-center img-rounded"
                    style={{ objectFit: 'cover' }}
                />
                <div className="text-lg mb-lg">404</div>
                <p className="lead m0">{t('title')}</p>
                <p>{t('subTitle')}</p>
            </div>
        </div>
    );
};

export default NotFound;
